<p-table [value]="form().controls">
    <ng-template pTemplate="body" let-rowGroup let-i="rowIndex">
        <tr [formGroup]="$any(rowGroup)">
            <td class="p-0"><spike-field-text formControlName="docPath" placeholder="C:\Users\nome_utente\file.txt"></spike-field-text></td>
            <td class="cursor-pointer p-0 " style="text-align: right;">
            @if(!isFormDisabled()){
                <div (click)="this.deleteRow.emit(i)"><i class="pi pi-trash" style="color: var(--p-button-text-danger-color)"></i></div>
             }
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        @if(!isFormDisabled()){
        <div class="flex">
            <div class="flex justify-content-end">
                <p-button label="Aggiungi file" icon="pi pi-plus" [text]="true" size="small" (onClick)="addRow.emit()"></p-button>
            </div>
        </div>
        }
    </ng-template>
</p-table>